import { Button, Card } from "antd";
import classNames from "classnames";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { OrderStatus } from "../utils";
import styles from "./OrderCardCore.module.scss";

interface OrderCardCoreProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
  status?: OrderStatus;
  showDetailsInitially?: boolean;
  isAlwaysOpen?: boolean;
  onViewClick?: () => void;
  viewDetails?: boolean;
  wrapperStyle?: string;
}

export const formatDateForOrderCard = (date: Date) => {
  return date.toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });
};

const OrderCardCore = ({
  title,
  children,
  onViewClick,
  status,
  showDetailsInitially = false,
  isAlwaysOpen = false,
  viewDetails = true,
  wrapperStyle,
}: OrderCardCoreProps) => {
  const [isOpen, setIsOpen] = useState(showDetailsInitially);

  const handleToggleDetails = () => {
    if (!isAlwaysOpen) {
      setIsOpen(!isOpen);
    }
  };

  return (
    <Card
      className={classNames(styles.card, {
        [styles.darkTheme]: status === "completed",
        [wrapperStyle]: wrapperStyle,
      })}
    >
      {title && (
        <button
          className={classNames(styles.title, {
            [styles.cursorPointer]: !isAlwaysOpen,
          })}
          onClick={handleToggleDetails}
        >
          {title}

          {!isAlwaysOpen && (
            <ChevronDown
              className={classNames(styles.chevron, {
                [styles.open]: isOpen,
                [styles.closed]: !isOpen,
              })}
            />
          )}
        </button>
      )}

      <div
        className={classNames(styles.contentWrapper, {
          [styles.openContent]: isOpen,
          [styles.closedContent]: !isOpen,
        })}
      >
        {isOpen && (
          <>
            {children}
            <Button
              type="link"
              className={styles.viewButton}
              onClick={() => onViewClick?.()}
            >
              View Details
            </Button>
          </>
        )}
      </div>

      {isAlwaysOpen && children}

      {isAlwaysOpen && viewDetails && (
        <Button
          type="link"
          className={styles.viewButton}
          onClick={() => onViewClick?.()}
        >
          View Details
        </Button>
      )}
    </Card>
  );
};

export default OrderCardCore;
